import { FC, useMemo, ReactElement, useCallback } from 'react'
import { FloatingPaneHeader } from 'components/features/pfm/FloatingPaneHeader/FloatingPaneHeader'
import { FloatingPaneFooter } from 'components/features/pfm/FloatingPaneFooter/FloatingPaneFooter'
import { FloatingPaneLayout } from 'components/features/pfm/FloatingPaneLayout/FloatingPaneLayout'
import { FLOATING_PANE_INVITE_FRIENDS_PANE } from 'components/features/inviteFriendsPane/constants/pane'
import { InviteFriendsContainer } from 'components/features/inviteFriendsPane/containers/InviteFriends'
import { killAllFloatingPanesActionCreator } from 'actions/floatingPanesActions'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import SvgIcon from 'components/atoms/SvgIcon'
import imageSVG from 'icons/invite_friends.svg?skip-svgo'
import styles from 'components/features/inviteFriendsPane/InviteFriendsPane.styl'

export const InviteFriendsPane: FC = () => {
  const dispatch = useStoreDispatch()

  const onCancel = useCallback(() => {
    dispatch(killAllFloatingPanesActionCreator())
  }, [dispatch])

  const headerChild = useMemo(() => (
    <FloatingPaneHeader
      title='Invite friends, get cash.'
      subTitle='Earn up to $1 per invite'
      onClose={ onCancel }
      theme='cyan'
      compact
    />
  ), [onCancel])

  const footerChild = useMemo<ReactElement | null>(() => {
    return (
      <FloatingPaneFooter
        cancelName='Cancel'
        onCancel={ onCancel }
      />
    )
  }, [onCancel])

  return (
    <FloatingPaneLayout
      type={ FLOATING_PANE_INVITE_FRIENDS_PANE }
      header={ headerChild }
      footer={ footerChild }
      bodyClassName={ styles.bodyContainer }
    >
      <div className={ styles.content }>
        <div className={ styles.imageWrapper }>
          <SvgIcon src={ imageSVG } useDefaultViewBox />
        </div>
        <InviteFriendsContainer />
      </div>
    </FloatingPaneLayout>
  )
}
